import { render } from "./CandidateProfileInterviews.vue?vue&type=template&id=a85aa590"
import script from "./CandidateProfileInterviews.vue?vue&type=script&lang=js"
export * from "./CandidateProfileInterviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__